export const API_KEY = 'AIzaSyBOg7X_LpCEJKE1tDINhBkcp3WRG-Jlpe8'